import React from 'react';

const OptionsContext = React.createContext({});

export default OptionsContext;
